export default __webpack_public_path__ + "static/media/Python_Icon.d8b377f0.png";